export default {"src":"/_next/static/media/algebra-tiles.d267430b.svg","height":115,"width":137,"blurWidth":0,"blurHeight":0};